import { render, staticRenderFns } from "./procurement_filters.vue?vue&type=template&id=1d17090a&scoped=true&"
import script from "./procurement_filters.vue?vue&type=script&lang=js&"
export * from "./procurement_filters.vue?vue&type=script&lang=js&"
import style0 from "./procurement_filters.vue?vue&type=style&index=0&id=1d17090a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d17090a",
  null
  
)

export default component.exports